<template>
	<v-container  align-center>
	
	<v-list class="pt-4 pl-2">
		<v-list-tile 
    		v-for="(item, index) in buildingFiles" 
    		:key="index" 
    		class="mb-2 datatile"	    		
    		align-start>
    		<v-layout row justify-space-between>

        		
        			<div style="padding:12px;"> Floor {{item.floor}}</div>
        			<v-spacer></v-spacer>
        			<v-btn  
                        color="blue lighten-2" 
                        @click="openLink(item.DWGURL)"
                        class="py-1 text-xs-right">
        				CAD
        			</v-btn>
                    <v-btn 
                        color="blue lighten-2" 
                        @click="openLink(item.PDFURL)"
                        class="py-1 text-xs-right" 
                        target="_blank">
        				PDF
        			</v-btn>
        		
        	</v-layout>
        </v-list-tile>
    </v-list>
	

	</v-container>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { AUTH_API_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'

let TabFiles = {
	name: TabFiles,
/*	mounted() {
    	this.fetchData()
  	},*/
	data() {
		return {}
	},

	computed: {
		...mapState({ buildingFiles: state => state.space.buildingFiles, }),
	},
	methods: {
    openLink (payload) {
      window.open(payload, '_blank');
    },
    /*
    //Using links obtained from floorplan API instead of obscured links
    //5/31/23 randy
        getPDF (payload) {
        var fileName = payload
        const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
        const fileNameNoPlus = fileName.replace(/\+/g, "[plus]");
        return new Promise((resolve, reject) => {
          fetch('https://pdc.arizona.edu/Floorplan.asmx/GetPDFFile?payload=' + fileNameNoPlus, {      
            headers: {
                  //'database' : this.getDatabase(),
                  'apiEsriToken' : apiEsriToken,
                  'Content-Type': 'application/pdf',
                  'Accept':'application/pdf',
            }})
            .then(response => response.json())
            .then(data => {
              //console.log(data)
              this.src = data
              window.open(data, '_blank');
            })
        })
      },
       getCAD (payload) {
        var fileName = payload
        const apiEsriToken = jscookie.get(AUTH_API_COOKIE)
        const fileNameNoPlus = fileName.replace(/\+/g, "[plus]");
        return new Promise((resolve, reject) => {
          fetch('https://pdc.arizona.edu/Floorplan.asmx/GetCADFile?payload=' + fileNameNoPlus, {      
            headers: {
                  //'database' : this.getDatabase(),
                  'apiEsriToken' : apiEsriToken,
                  'Content-Type': 'application/pdf',
                  'Accept':'application/pdf',
            }})
            .then(response => response.json())
            .then(data => {
              //console.log(data)
              this.src = data
              window.open(data);
            })
        })
      },*/
    }
}

export default TabFiles

</script>

<style>



/*.search {
	padding-left: 150px;
}

label {
	padding-left: 150px;
}*/


</style>





// WEBPACK FOOTER //
// src/components/buildingcard/TabFiles.vue